var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuHomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_menu_home_filled_svg__clip0_37861_11256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17h-4v10a2 2 0 01-2 2h-3.5v-6.087A2.917 2.917 0 0017.587 20h-3.174a2.917 2.917 0 00-2.913 2.913V29H8a2 2 0 01-2-2V17H2L16 3l14 14zm-12.413 5c.504 0 .913.41.913.913V29h-5v-6.087c0-.504.41-.913.913-.913h3.174z",
    fill: "#228622"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_menu_home_filled_svg__clip0_37861_11256"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconMenuHomeFilled;